import { Subject } from "rxjs";
import { BroadcastPreset } from "./broadcast-preset";
import {
  assetBlockItemExtendedData,
  broadcastAssetItemExtendedData,
} from "./asset-block-item-extended-data";
import { SwitcherItem } from "./switcher-item";
export enum ELiveBroadcastingAction {
  UpdateEngineChannelFullPlaylist = 0,
  SkipToItem = 1,
  SendEmptyList = 2,
  UpdateEngineChannelPlaylistWithoutPreroll = 3,
  InvalidateControllerCache = 4,
  GetControllerCache = 5,
  AddAssetItemsToPrerollList = 6,
  CreateChannelCacheWithFullPlaylist = 7,
  SkipToSingleItem = 8,
  RemoveAssetItemsFromPrerollList = 9,
  AddNextItemToPlaylist = 10,
  RemoveItemFromPlaylist = 11,
  SkipToStack = 12,
  SkipFromStack = 13,
  UpdateOperationalChannelCache = 14,
  UpdateLiveBroadcastShowUid = 15,
  GetLiveFeedAudioChannels = 16,
  AddLiveFeedAudioChannelToPreroll = 17,
  AddLiveFeedAudioChannelToMediaList = 18,
  UpdateAudioChannelVolume = 19,
  SkipToItemAndSkipFromStack = 20,
  SkipToBlock = 21,
  UpdateStackWarmup = 22,
}
export abstract class IBroadcastsRepository {
  updated: Subject<BroadcastPreset>;
  created: Subject<BroadcastPreset>;
  deleted: Subject<BroadcastPreset>;
  blockTypeChanged: Subject<SwitcherItem>;
  abstract get(
    nameFilter?: string,
    broadcastId?: string,
  ): Promise<BroadcastPreset[]>;
  abstract create(broadcastToCreate: BroadcastPreset): Promise<void>;
  abstract update(broadcastPreset: BroadcastPreset): Promise<void>;
  abstract delete(broadcastId: string): Promise<void>;
  abstract getBlockExtendedData(
    broadcastUid: string,
    switcherItem: SwitcherItem,
  ): Promise<assetBlockItemExtendedData>;
  abstract updateBlockExtendedData(
    broadcastUid: string,
    assetId: string | number,
    assetUid: string,
    extendedData: assetBlockItemExtendedData,
    pushUpdate?: boolean,
  ): Promise<void>;
  abstract changeBlockType(
    switcherItem: SwitcherItem,
    broadcastUid: string,
  ): Promise<void>;
  abstract refreshBroadcastPreset(broadcastPresetUid: string): Promise<void>;
}
